import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    const d = err.response?.data?.detail;
    if (err.response?.status === 401 && typeof d === "string" && /sess[aã]o foi encerrada/i.test(d)) {
      try { sessionStorage.setItem("iep-session-msg", d); } catch (e) {}
    }
    if (err.response?.status === 503 && typeof d === "string" && d.startsWith("MANUTENCAO")) {
      try { window.dispatchEvent(new Event("manutencao")); } catch (e) {}
    }
    if (err.response?.status === 403 && typeof d === "string" && d.startsWith("CONTRATO_PENDENTE")) {
      try { window.dispatchEvent(new Event("contract-pending")); } catch (e) {}
    }
    return Promise.reject(err);
  },
);

// consultas automáticas (sino, mensagens, "online agora"): não contam como uso para a inatividade
export const bg = { headers: { "X-IEP-BG": "1" } };

export function formatApiError(detail) {
  if (detail == null) return "Ocorreu um erro. Tente novamente.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

// professora que também é aluna: o cookie de sessão "iep_area" diz em qual área ela está (o servidor lê o mesmo cookie)
export function setArea(area) {
  try {
    document.cookie = area === "aluno" ? "iep_area=aluno; path=/; SameSite=Lax; Secure" : "iep_area=; path=/; max-age=0; SameSite=Lax; Secure";
  } catch (e) { /* sem cookie: segue como professora */ }
}
